<template>
  <div v-if="showModals" id="overlay">
    <div class="overlay-modal-container" @click="closeModal" />
    <div>
      <OverlayProduct v-if="currentOverlayModal === 'product'" />
      <OverlayPanorama v-if="currentOverlayModal === 'panoramavy'" />
    </div>
  </div>
</template>

<script>
import OverlayProduct from '@/components/products/OverlayProduct/OverlayProduct.vue'
import OverlayPanorama from '@/components/general/panormaview/OverlayPanoramView.vue'
import { SET_STATUS_ON_SHOW_OVERLAY_MODAL } from '@/store/mutation-types'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'OverlayModal',
  components: {
    OverlayProduct,
    OverlayPanorama
  },
  data() {
    return {
      isModalClosed: false
    }
  },
  computed: {
    ...mapState({
      showModals: (state) => state.showOverlayModal,
      currentOverlayModal: (state) => state.currentOverlayModal
    })
  },
  methods: {
    closeModal() {
      this.isModalClosed = true
      this.toggleModal({ toggleModal: false })
      setTimeout(() => {
        this.isModalClosed = false
      }, 500)
    },
    ...mapMutations({
      toggleModal: SET_STATUS_ON_SHOW_OVERLAY_MODAL
    })
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;

.overlay-modal-container {
  background-color: old-variables.$color-background-navigation-menu;
  position: fixed;
  z-index: variables.$z-index-overlay;
  left: 0;
  top: variables.$layout-top-bar-height;
  width: calc(100vw);
  height: calc(100vh - #{variables.$layout-top-bar-height});
  min-height: auto;
}

.modal {
  z-index: variables.$z-index-overlay-modal;
}

@media screen and (max-width: 1024px) {
  .infoDisplay {
    width: 100%;
    height: 100%;
  }
  .overlay-modal-container--panoramavy {
    display: none;
  }
}
</style>
